import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const BannerCard = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  color: ${tokens.colors.basics[0]};
  font-size: ${tokens.typography.fontSize["2xl"]};
  font-weight: ${tokens.typography.fontWeight.semibold};
  margin: 0 0 12px 0;
`;

export const Description = styled.div`
  p {
    color: ${tokens.colors.basics[0]};
    font-size: ${tokens.typography.fontSize.sm};
    line-height: ${tokens.typography.lineHeight.normal};
    margin: 0;
  }
`;
